import React from 'react';
import PropTypes from 'prop-types';
import YoutubeVideoEmbed from 'epic-react-common/src/components/YoutubeVideoEmbed';
import root from 'window-or-global';

export default class Video extends React.Component {
    static propTypes = {
        video: PropTypes.string,
        align: PropTypes.string,
        active: PropTypes.bool,
        play: PropTypes.bool,
        playPauseFunc: PropTypes.func,
        poster: PropTypes.bool,
        backShadow: PropTypes.bool,
        buttonColor: PropTypes.string
    };

    videoOptions = {
        playerVars: {
            width: '100%',
            height: '100%',
            showinfo: 0,
            controls: 1,
            autohide: 0,
            cc_load_policy: 0,
            disablekb: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            loop: 0
        }
    };

    render() {
        let disableAutoPlay = false; //auto play on mobile browsers can behave badly.
        try {
            disableAutoPlay = root._epicGamesNav.browser.mobile || root._epicGamesNav.browser.tablet;
        } catch (e) {
            console.error('Failed to read mobile and tablet bool from browser');
        }

        const {active, video} = this.props;
        const contentStyle = active ? 'content-vid active' : 'content-vid not-visible';
        const embedStyle = 'youtube-video-embed embed-responsive embed-responsive-16by9';
        const playOverlay = this.props.poster ? (
            <div role="presentation" className={`play-pause-overlay ${this.props.play ? '' : 'show'}`} onClick={this.props.playPauseFunc}>
                <div className="container-fluid play-pause-btn">
                    <button className={`${this.props.buttonColor}`}>
                        <span className="icon-play" />
                    </button>
                </div>
            </div>
        ) : (
            <div className={`container-fluid play-btn ${this.props.play ? '' : 'show'}`}>
                <button className={`${this.props.buttonColor}`} onClick={this.props.playPauseFunc}>
                    <span className="icon-play" />
                </button>
            </div>
        );

        return (
            <div id="video" className={this.props.play ? 'video-container play-view' : `video-container ${this.props.align}`}>
                <div className={`${contentStyle}`}>
                    <div className={this.props.backShadow ? `${embedStyle} backShadow` : embedStyle}>
                        <div className={`youtube-video trailer-video embed-responsive-item ${active ? 'show' : ''}`}>
                            {playOverlay}
                            {/* Using BackgroundVideo was hiding controls on mobile */}
                            <YoutubeVideoEmbed
                                video={video}
                                videoOptions={this.videoOptions}
                                mute={false}
                                loop={true}
                                play={disableAutoPlay ? false : this.props.play} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
